import { type HighlightsController } from '@databases/highlights';
import { createFocusBoxEffect } from '@databases/selections';
import { getService } from '@databases/service-container';
import { DatabaseLayoutType } from '@databases/types/database/view';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export interface FocusBoxEffectFeatureDeps {
  highlightsController: HighlightsController;
}

export function createFocusBoxEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.FOCUS_BOX_EFFECT,
    type: 'effect',
    isEnabled: (ctx) => ctx.layoutType === DatabaseLayoutType.TABLE,
    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createFocusBoxEffect(highlightsController);
    },
  };
}
